/* eslint-disable */
import React from "react";
import "./styles.scss";
import BarChartIcon from "@mui/icons-material/BarChart";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import LaunchIcon from "@mui/icons-material/Launch";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import RuleIcon from "@mui/icons-material/Rule";
import SendIcon from "@mui/icons-material/Send";
import { connect } from "react-redux";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { legacyDashboardTarget } from "@/v2/containers/mapContainerV2/legacyMapRoutes";
import { clearErrorMessage, getAdminDetails } from "../../actions/auth";
import { cityList, getCities, selectCity } from "../../actions/cities";
import { getDockStatuses, getDocks } from "../../actions/docks";
import { getLocks } from "../../actions/locks";
import { getPayment } from "../../actions/payment";
import { getRentals } from "../../actions/rentals";
import {
  setCurrentPageValue,
  setFilterValue,
  setOrder,
  setOrderBy,
  setSearchValue,
} from "../../actions/screen";
import { getStations, getStationsOnMap } from "../../actions/stations";
import { getUsers } from "../../actions/users";
import { getBikeStatus, getBikeTypes, getVehicle } from "../../actions/vehicle";
import { getLegacyUserIdsByTag } from "../../apis/tags/tag-apis";
import Header from "../../components/header";
import DashboardItem from "../../components/items/dashboardItem";
import { getCurrentVersion } from "../../configs/localVCS";
import { ASC } from "../../constants/const";
import { FILTER_BY_TAG } from "../../constants/filterConst";
import * as routes from "../../constants/routes";
import { useShowToast, useTheme } from "../../hooks";
import { useIsAdminAsset } from "../../hooks/user-hooks";
import { strings } from "../../I18n";
import admin from "../../images/admin-with-cogwheels.png";
import bike from "../../images/bike.png";
import bookingsIcon from "../../images/bookingsIcon.png";
import city from "../../images/city.png";
import couponIcon from "../../images/coupon.png";
import dock from "../../images/dock.png";
import home from "../../images/home.png";
import lanterneLogo from "../../images/lanterne-logo-dark.png";
import referralIcon from "../../images/referral.png";
import rentals from "../../images/rentals.png";
import settingsIcon from "../../images/settings.png";
import station from "../../images/station.png";
import transaction from "../../images/transaction.png";
import user from "../../images/user.png";
import {
  filterUrl,
  isSuperAdmin,
  isSuperAdminOrCityAdmin,
} from "../../utils/utils";
import { AnalyticsContainer } from "../analyticsContainer/AnalyticsContainer";
import { AssetAssets } from "../asset/assetAssets/AssetAssets";
import { AssetBookings } from "../asset/assetBookings/AssetBookings";
import { AssetProjects } from "../asset/assetProjects/AssetProjects";
import BikeContainer from "../bikeContainer";
import BikeHistoryContainer from "../bikeHistoryContainer";
import BookingScreen from "../bookingContainer";
import CityContainer from "../cityContainer";
import ClientContainer from "../clientContainer";
import CouponsContainer from "../couponsContainer";
import CouponUserScreen from "../couponUserContainer";
import DockContainer from "../dockContainer";
import { IntrosContainer } from "../intros/IntrosContainer";
import MFAContainer from "../MFAContainer";
import MapContainerV2 from "../mapContainerV2";
import NotFound from "../NotFoundContainer";
import { NotificationsContainer } from "../notificationsContainer/NotificationsContainer";
import { PricingPlanDomains } from "../pricingPlanDomains/PricingPlanDomains";
import PricingPlanEditor from "../pricingPlanEditor";
import PromotionsContainer from "../promotionsContainer";
import ReferralsContainer from "../referralsContainer";
import { RentalRulesContainer } from "../rentalRules/RentalRulesContainer";
import RentalsContainer from "../rentalsContainer";
import { RentalsGallery } from "../rentalsGallery/RentalsGallery";
import { ReservationsContainer } from "../reservations/ReservationsContainer";
import SettingsContainer from "../SettingsContainer";
import { ServiceAccountsContainer } from "../serviceAccounts/ServiceAccountsContainer";
import StationContainer from "../stationContainer";
import TransactionContainer from "../transactionContainer";
import UserLedger from "../userLedger";
import UserManagementScreen from "../userManagementContainer";
import { WarningsContainer } from "../warnings/WarningsContainer";
import { AssetsMenu } from "./AssetsMenu";

function DashboardScreen(props) {
  const {
    errorMessage,
    clearErrorMessage,
    removeUserSuccess,
    citiesList,
    pageSize,
    setSearchValue,
    setFilterValue,
    setCurrentPageValue,
    searchValue,
    filterValue,
    currentPageValue,
    setOrder,
    setOrderBy,
    order,
    orderBy,
    savedCity,
    typeFilter,
    stationTypeFilter,
    stationStateFilter,
    bikeStateFilter,
    adminDetails,
    getDockStatuses,
  } = props;

  const showToast = useShowToast();
  const theme = useTheme();
  const [searchTimeout, setSearchTimeout] = React.useState(0);
  const isAdminAsset = useIsAdminAsset();
  const [resolvedTagUserIds, setResolvedTagUserIds] = React.useState(null);
  const [tagFilterLoading, setTagFilterLoading] = React.useState(false);
  const [tagFilterTotalCount, setTagFilterTotalCount] = React.useState(0);
  const [tagFilterRefresh, setTagFilterRefresh] = React.useState(0);

  const navigate = useNavigate();
  const location = useLocation();

  React.useEffect(() => {
    const preferV1 = sessionStorage.getItem("preferV1UI") === "true";
    if (adminDetails && !preferV1) {
      const v2Path = legacyDashboardTarget(
        location.pathname,
        location.search,
        isAdminAsset,
        location.hash
      );
      navigate(v2Path, { replace: true });
    }
  }, [
    adminDetails,
    isAdminAsset,
    location.pathname,
    location.search,
    location.hash,
    navigate,
  ]);

  const orderProps = {
    order,
    setOrder,
    orderBy,
    setOrderBy,
  };

  const filterProps = {
    filterValue,
    setFilterValue,
  };

  const orderValue = React.useMemo(
    () => (orderBy === "" ? "" : `${orderBy},${order}`),
    [orderBy, order]
  );

  const tagFilterItem = React.useMemo(
    () => filterValue?.find((f) => f.filterBy === FILTER_BY_TAG),
    [filterValue]
  );

  const tagFilterData = React.useMemo(() => {
    if (!tagFilterItem) {
      return { ids: [], match: "OR" };
    }

    if (
      tagFilterItem.filter &&
      typeof tagFilterItem.filter === "object" &&
      !Array.isArray(tagFilterItem.filter)
    ) {
      return {
        ids: Array.isArray(tagFilterItem.filter.ids)
          ? tagFilterItem.filter.ids
          : [],
        match: tagFilterItem.filter.match || "OR",
      };
    }

    const ids = Array.isArray(tagFilterItem.filter)
      ? tagFilterItem.filter
      : [tagFilterItem.filter].filter(Boolean);

    return { ids, match: "OR" };
  }, [tagFilterItem]);

  React.useEffect(() => {
    if (!tagFilterItem) {
      setResolvedTagUserIds(null);
      setTagFilterLoading(false);
      setTagFilterTotalCount(0);
      return;
    }

    const abortController = new AbortController();
    const tagFilterValues = tagFilterData.ids;

    const resolveTagFilter = async () => {
      setTagFilterLoading(true);
      try {
        const result = await getLegacyUserIdsByTag(
          tagFilterValues,
          tagFilterData.match
        );
        if (!abortController.signal.aborted) {
          setResolvedTagUserIds(result.legacyUserIds);
          setTagFilterTotalCount(result.totalCount);
        }
      } catch (e) {
        if (!abortController.signal.aborted) {
          console.error("Failed to resolve tag filter:", e);
          setResolvedTagUserIds([]);
          setTagFilterTotalCount(0);
          showToast("Failed to load tag filter", "error");
        }
      } finally {
        if (!abortController.signal.aborted) {
          setTagFilterLoading(false);
        }
      }
    };

    resolveTagFilter();

    return () => {
      abortController.abort();
    };
  }, [tagFilterItem, tagFilterData, tagFilterRefresh]);

  const currentfilterValue = React.useMemo(() => {
    if (!filterValue) return "";
    let baseFilter = filterUrl(filterValue, props.citiesList);
    if (tagFilterItem && resolvedTagUserIds !== null) {
      if (resolvedTagUserIds.length > 0) {
        const userIdsFilter = `userIds=${resolvedTagUserIds.join(",")}`;
        baseFilter = baseFilter
          ? `${baseFilter}&${userIdsFilter}`
          : userIdsFilter;
      } else {
        const userIdsFilter = "userIds=-1";
        baseFilter = baseFilter
          ? `${baseFilter}&${userIdsFilter}`
          : userIdsFilter;
      }
    }
    return baseFilter;
  }, [filterValue, props.citiesList, tagFilterItem, resolvedTagUserIds]);

  React.useEffect(() => {
    if (errorMessage !== null) {
      showToast(errorMessage, "error");
      clearErrorMessage();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorMessage, clearErrorMessage]);

  React.useEffect(() => {
    if (removeUserSuccess !== null) {
      props.getUsers(
        currentPageValue,
        searchValue,
        orderValue,
        currentfilterValue,
        Math.min(pageSize, 100)
      );
      // showToast(strings('message.removeUserSuccess'), 'success')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [removeUserSuccess]);

  const loader = () => {
    switch (location.pathname) {
      case routes.DASHBOARD_SCREEN:
        props.getBikeStatus();
        break;
      case routes.DASHBOARD_USERS: {
        // When tag filter is active, IDs are already paginated from user_records,
        // so request page 0 from legacy backend
        const effectivePage = tagFilterItem ? 0 : currentPageValue;
        props.getUsers(
          effectivePage,
          searchValue,
          orderValue,
          // will remove this to defaul
          currentfilterValue +
            (savedCity
              ? "&" + savedCity
              : adminDetails?.cityId
                ? "&cityId=" + adminDetails.cityId
                : ""),
          Math.min(pageSize, 100)
        );
        break;
      }
      case routes.DASHBOARD_TRANSACTIONS:
        props.getPayment(
          currentPageValue,
          searchValue,
          orderValue,
          currentfilterValue + (savedCity ? "&" + savedCity : ""),
          pageSize
        );
        break;
      case routes.DASHBOARD_BIKES:
      case routes.DASHBOARD_STATIONS:
        break;
      case routes.DASHBOARD_DOCKS:
        props.getDocks(
          currentPageValue,
          searchValue,
          orderValue,
          currentfilterValue + (savedCity ? "&" + savedCity : ""),
          pageSize
        );
        getDockStatuses();
        break;
      case routes.DASHBOARD_CITIES:
        props.getCities(
          currentPageValue,
          searchValue,
          orderValue,
          currentfilterValue,
          pageSize
        );
        break;
      case routes.DASHBOARD_RENTALS:
        break;
      default:
        checkParamForNewTab();
        break;
    }
  };

  const checkParamForNewTab = () => {
    const path = location.pathname;
    const pathParts = path.split("/");
    const id = pathParts[3];

    if (path.startsWith("/dashboard/user/")) {
      props.getUsers(
        currentPageValue,
        searchValue,
        orderValue,
        currentfilterValue +
          (id ? `&userId=${id}` : "") +
          (savedCity ? "&" + savedCity : ""),
        pageSize
      );
      return;
    }

    if (path.startsWith("/dashboard/bike/")) {
      props.getBikeTypes();
      return;
    }

    if (path.startsWith("/dashboard/transaction/")) {
      searchValue &&
        props.getPayment(
          currentPageValue,
          searchValue,
          orderValue,
          savedCity ? "&" + savedCity : "",
          pageSize
        );
      return;
    }
  };

  React.useEffect(() => {
    // Wait for tag filter to be resolved before loading
    if (tagFilterItem && tagFilterLoading) {
      return;
    }
    if (currentPageValue === 0) {
      setSearchTimeout(setTimeout(loader, 500));
    } else {
      setCurrentPageValue(0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    savedCity,
    pageSize,
    filterValue,
    searchValue,
    adminDetails,
    tagFilterLoading,
  ]);

  React.useEffect(() => {
    // Wait for tag filter to be resolved before loading
    if (tagFilterItem && tagFilterLoading) {
      return;
    }
    setSearchTimeout(setTimeout(loader, 500));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderBy, order, currentPageValue, tagFilterLoading]);

  React.useEffect(() => {
    setFilterValue(null);
  }, [savedCity]);

  const refreshProps = () => {
    setSearchValue("");
    setFilterValue(null);
    setOrder(ASC);
    setOrderBy("");
    setCurrentPageValue(0);
  };

  const pressOnDashboard = () => {
    refreshProps();
    props.getStationsOnMap(
      typeFilter,
      stationTypeFilter,
      stationStateFilter,
      bikeStateFilter,
      savedCity
    );
    navigate(routes.DASHBOARD_SCREEN);
  };

  const pressOnUserMenu = () => {
    refreshProps();
    // will remove this to defaul
    props.getUsers(
      0,
      "",
      "",
      savedCity
        ? "&" + savedCity
        : adminDetails?.cityId
          ? "&cityId=" + adminDetails.cityId
          : "",
      pageSize
    );
    navigate(routes.DASHBOARD_USERS);
  };

  const pressOnStationsMenu = () => {
    // props.getStations(0, '', '', savedCity || '', pageSize)
    refreshProps();
    navigate(routes.DASHBOARD_STATIONS);
  };

  const pressOnTransactionsMenu = () => {
    props.getPayment(0, "", "", savedCity || "", pageSize);
    refreshProps();
    navigate(routes.DASHBOARD_TRANSACTIONS);
  };

  const pressOnBikeMenu = () => {
    // props.getVehicle(0, '', '', savedCity || '', pageSize)
    props.getBikeTypes();
    refreshProps();
    navigate(routes.DASHBOARD_BIKES);
  };

  const pressOnDockMenu = () => {
    props.getDocks(0, "", "", savedCity || "", pageSize);
    refreshProps();
    getDockStatuses();
    navigate(routes.DASHBOARD_DOCKS);
  };

  const pressOnCitiesMenu = () => {
    refreshProps();
    props.getCities(0, "", "", "", pageSize);
    navigate(routes.DASHBOARD_CITIES);
  };

  const pressOnPromotionsMenu = () => {
    refreshProps();
    navigate(routes.PROMOTIONS_ROUTE);
  };

  const pressOnCouponsMenu = () => {
    refreshProps();
    navigate(routes.COUPONS_ROUTE);
  };

  const pressOnReferralsMenu = () => {
    refreshProps();
    navigate(routes.REFERRAL_ROUTE);
  };

  const pressOnBookingsMenu = () => {
    refreshProps();
    props.getCities(0, "", "", "", pageSize);
    navigate(routes.BOOKING_ROUTE);
  };
  const pressOnNotificationsMenu = () => {
    refreshProps();
    navigate(routes.NOTIFICATIONS_ROUTE);
  };
  const pressOnSettingsMenu = () => {
    refreshProps();
    props.getCities(0, "", "", "", pageSize);
    navigate(routes.SETTINGS_ROUTE);
  };

  const pressOnRentalsMenu = () => {
    // props.getRentals(0, '', '', savedCity || '', pageSize)
    refreshProps();
    navigate(routes.DASHBOARD_RENTALS);
  };

  const pressOnRentalRulesMenu = () => {
    refreshProps();
    navigate(routes.DASHBOARD_RENTAL_RULES);
  };

  const pressOnUserManagementMenu = () => {
    refreshProps();
    navigate(routes.USER_MANAGEMENT_ROUTE);
  };

  const changeSearch = ({ target }) => {
    if (searchTimeout) {
      clearTimeout(searchTimeout);
    }
    setSearchValue(target.value);
  };

  const clearSearchValue = () => setSearchValue("");

  let pages;
  if (isAdminAsset) {
    pages = [
      {
        path: routes.ASSET_PROJECTS,
        Component: AssetProjects,
      },
      {
        path: routes.ASSET_ASSETS,
        Component: AssetAssets,
      },
      {
        path: routes.ASSET_BOOKINGS,
        Component: AssetBookings,
      },
    ];
  } else {
    pages = [
      {
        path: routes.MFA_ROUTE,
        Component: MFAContainer,
      },
      {
        path: routes.DASHBOARD_USERS,
        extraProps: {
          changeSearch: changeSearch,
          searchValue: searchValue,
          clearSearchValue: clearSearchValue,
          changePage: setCurrentPageValue,
          orderProps: orderProps,
          filterProps: filterProps,
          tagFilterTotalCount: tagFilterItem ? tagFilterTotalCount : null,
          currentPageValue: currentPageValue,
        },
        Component: ClientContainer,
      },
      {
        path: routes.DASHBOARD_BIKES,
        extraProps: {
          changeSearch: changeSearch,
          searchValue: searchValue,
          clearSearchValue: clearSearchValue,
          changePage: setCurrentPageValue,
          orderProps: orderProps,
          orderValue: orderValue,
          filterProps: filterProps,
        },
        Component: BikeContainer,
      },
      {
        path: routes.DASHBOARD_STATIONS,
        extraProps: {
          changeSearch: changeSearch,
          searchValue: searchValue,
          clearSearchValue: clearSearchValue,
          changePage: setCurrentPageValue,
          orderProps: orderProps,
          filterProps: filterProps,
        },
        Component: StationContainer,
      },
      {
        path: routes.DASHBOARD_DOCKS,
        extraProps: {
          changeSearch: changeSearch,
          searchValue: searchValue,
          clearSearchValue: clearSearchValue,
          changePage: setCurrentPageValue,
          orderProps: orderProps,
          filterProps: filterProps,
        },
        Component: DockContainer,
      },
      {
        path: routes.DASHBOARD_RENTALS,
        extraProps: {
          changeSearch: changeSearch,
          searchValue: searchValue,
          clearSearchValue: clearSearchValue,
          changePage: setCurrentPageValue,
          orderProps: orderProps,
          orderValue: orderValue,
          filterProps: filterProps,
        },
        Component: RentalsContainer,
      },
      {
        path: routes.DASHBOARD_RENTALS_GALLERY,
        Component: RentalsGallery,
      },
      {
        path: routes.DASHBOARD_RENTAL_RULES,
        Component: RentalRulesContainer,
      },
      {
        path: routes.DASHBOARD_TRANSACTIONS,
        extraProps: {
          changeSearch: changeSearch,
          searchValue: searchValue,
          clearSearchValue: clearSearchValue,
          changePage: setCurrentPageValue,
          orderProps: orderProps,
          filterProps: filterProps,
        },
        Component: TransactionContainer,
      },
      {
        path: routes.BIKE_HISTORY,
        Component: BikeHistoryContainer,
      },
      {
        path: routes.USER_LEDGER,
        Component: UserLedger,
      },
      {
        path: routes.DASHBOARD_CUSTOMER,
        Component: UserLedger,
        requiresNewBackend: true,
      },
      {
        path: routes.USER_MANAGEMENT_ROUTE,
        Component: UserManagementScreen,
      },
      {
        path: routes.SERVICE_ACCOUNTS_ROUTE,
        Component: ServiceAccountsContainer,
      },
      {
        path: routes.PROMOTIONS_ROUTE + "/*",
        Component: PromotionsContainer,
      },
      {
        path: routes.COUPONS_ROUTE,
        Component: CouponsContainer,
      },
      {
        path: routes.REFERRAL_ROUTE,
        Component: ReferralsContainer,
      },
      {
        path: routes.PRICING_PLAN_EDITOR_ROUTE,
        Component: PricingPlanEditor,
      },
      {
        path: routes.PRICING_PLAN_EDITOR_CREATE_ROUTE,
        Component: PricingPlanEditor,
      },
      {
        path: routes.PRICING_PLAN_DOMAINS_ROUTE,
        Component: PricingPlanDomains,
      },
      {
        path: routes.USER_COUPON_ROUTE,
        Component: CouponUserScreen,
      },
      {
        path: routes.INTROS_ROUTE,
        Component: IntrosContainer,
      },
      {
        path: routes.WARNINGS_ROUTE,
        Component: WarningsContainer,
      },
      {
        path: routes.DASHBOARD_RESERVATIONS,
        Component: ReservationsContainer,
        requiresNewBackend: true,
      },
      {
        path: routes.DASHBOARD_ANALYTICS,
        Component: AnalyticsContainer,
      },
      {
        path: routes.DASHBOARD_USER,
        extraProps: {
          changeSearch: changeSearch,
          searchValue: searchValue,
          clearSearchValue: clearSearchValue,
          changePage: setCurrentPageValue,
          orderProps: orderProps,
          filterProps: filterProps,
          tagFilterTotalCount: tagFilterItem ? tagFilterTotalCount : null,
          currentPageValue: currentPageValue,
        },
        Component: ClientContainer,
      },
      {
        path: routes.DASHBOARD_BIKE,
        extraProps: {
          changeSearch: changeSearch,
          searchValue: searchValue,
          clearSearchValue: clearSearchValue,
          changePage: setCurrentPageValue,
          orderProps: orderProps,
          filterProps: filterProps,
        },
        Component: BikeContainer,
      },
      {
        path: routes.DASHBOARD_TRANSACTION,
        extraProps: {
          changeSearch: changeSearch,
          searchValue: searchValue,
          clearSearchValue: clearSearchValue,
          changePage: setCurrentPageValue,
          orderProps: orderProps,
          filterProps: filterProps,
        },
        Component: TransactionContainer,
      },
      {
        path: "",
        Component: MapContainerV2,
      },
      {
        path: routes.DASHBOARD_MAP,
        Component: MapContainerV2,
      },
    ];
  }

  return (
    <div>
      <Header cities={citiesList} city={props.city} />
      <div className="dashboard">
        {isAdminAsset && <AssetsMenu navigate={() => pressOnUserMenu()} />}

        {!isAdminAsset && (
          <div className="dashboardMenu">
            <DashboardItem
              name={strings("descriptions.dashboard")}
              icon={home}
              action={pressOnDashboard}
              isSelected={location.pathname === routes.DASHBOARD_SCREEN}
            />
            <DashboardItem
              name={strings("descriptions.bikes")}
              icon={bike}
              action={pressOnBikeMenu}
              isSelected={location.pathname === routes.DASHBOARD_BIKES}
              route={routes.DASHBOARD_BIKES}
            />
            <DashboardItem
              name={strings("descriptions.zones")}
              icon={station}
              action={pressOnStationsMenu}
              isSelected={location.pathname === routes.DASHBOARD_STATIONS}
              route={routes.DASHBOARD_STATIONS}
            />
            <DashboardItem
              name={strings("descriptions.docks")}
              icon={dock}
              action={pressOnDockMenu}
              isSelected={location.pathname === routes.DASHBOARD_DOCKS}
              route={routes.DASHBOARD_DOCKS}
            />
            <DashboardItem
              name={strings("descriptions.rentals")}
              icon={rentals}
              action={pressOnRentalsMenu}
              isSelected={location.pathname === routes.DASHBOARD_RENTALS}
              route={routes.DASHBOARD_RENTALS}
            />
            {(isSuperAdmin(adminDetails) ||
              (isSuperAdminOrCityAdmin(adminDetails) &&
                adminDetails?.newBackendEnabled)) && (
              <DashboardItem
                name={"Reservations"}
                IconComponent={EventAvailableIcon}
                action={() => navigate(routes.DASHBOARD_RESERVATIONS)}
                isSelected={location.pathname === routes.DASHBOARD_RESERVATIONS}
                route={routes.DASHBOARD_RESERVATIONS}
              />
            )}
            {isSuperAdminOrCityAdmin(adminDetails) && (
              <DashboardItem
                name={strings("descriptions.rentalRules")}
                IconComponent={RuleIcon}
                action={pressOnRentalRulesMenu}
                isSelected={location.pathname === routes.DASHBOARD_RENTAL_RULES}
                route={routes.DASHBOARD_RENTAL_RULES}
              />
            )}
            <DashboardItem
              name={strings("descriptions.transactions")}
              icon={transaction}
              action={pressOnTransactionsMenu}
              isSelected={location.pathname === routes.DASHBOARD_TRANSACTIONS}
              route={routes.DASHBOARD_TRANSACTIONS}
            />
            <DashboardItem
              name={strings("descriptions.users")}
              icon={user}
              action={pressOnUserMenu}
              isSelected={location.pathname === routes.DASHBOARD_USERS}
              route={routes.DASHBOARD_USERS}
            />

            {isSuperAdmin(adminDetails) || adminDetails?.newBackendEnabled ? (
              <DashboardItem
                name={"Promotions"}
                IconComponent={LocalOfferIcon}
                action={pressOnPromotionsMenu}
                isSelected={location.pathname.startsWith(
                  routes.PROMOTIONS_ROUTE
                )}
                route={routes.PROMOTIONS_ROUTE}
              />
            ) : (
              <>
                <DashboardItem
                  name={"Coupons"}
                  icon={couponIcon}
                  action={pressOnCouponsMenu}
                  isSelected={location.pathname === routes.COUPONS_ROUTE}
                  route={routes.COUPONS_ROUTE}
                />
                <DashboardItem
                  name={"Referral"}
                  icon={referralIcon}
                  action={pressOnReferralsMenu}
                  isSelected={location.pathname === routes.REFERRAL_ROUTE}
                  route={routes.REFERRAL_ROUTE}
                />
              </>
            )}

            {(isSuperAdmin(adminDetails) ||
              adminDetails?.newBackendEnabled) && (
              <DashboardItem
                name={"Analytics"}
                IconComponent={BarChartIcon}
                action={() => navigate(routes.DASHBOARD_ANALYTICS)}
                isSelected={location.pathname === routes.DASHBOARD_ANALYTICS}
                route={routes.DASHBOARD_ANALYTICS}
                badge="Beta"
                badgeColor={theme?.navBackground}
              />
            )}

            {adminDetails?.whiteLabelId === 999 && (
              <a
                href="https://dashboard.lanterne.ai/fleets/dashboard?fleet=lisa-demo"
                target="_blank"
                rel="noopener noreferrer"
                className="dashboardItem"
                style={{
                  background: "white",
                  textDecoration: "none",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
                title="Opens Lanterne operations platform in new tab"
              >
                <img src={lanterneLogo} alt="Lanterne" height="22" width="22" />
                <div style={{ flex: 1 }}>
                  <p className="item" style={{ margin: 0, fontWeight: 500 }}>
                    Lanterne
                  </p>
                  <p style={{ margin: 0, fontSize: "10px", color: "#666" }}>
                    Operations platform
                  </p>
                </div>
                <LaunchIcon sx={{ width: 16, height: 16, color: "#083f6d" }} />
              </a>
            )}

            {isSuperAdminOrCityAdmin(adminDetails) && (
              <DashboardItem
                isHeaderItem={true}
                name={strings("descriptions.administration")}
                icon={admin}
              />
            )}

            {isSuperAdminOrCityAdmin(adminDetails) && (
              <DashboardItem
                name={strings("descriptions.cities")}
                icon={city}
                action={pressOnCitiesMenu}
                isSelected={location.pathname === routes.DASHBOARD_CITIES}
                route={routes.DASHBOARD_CITIES}
              />
            )}
            {isSuperAdmin(adminDetails) && (
              <DashboardItem
                name={"User Management"}
                icon={couponIcon}
                action={pressOnUserManagementMenu}
                isSelected={location.pathname === routes.USER_MANAGEMENT_ROUTE}
                route={routes.USER_MANAGEMENT_ROUTE}
              />
            )}
            {isSuperAdmin(adminDetails) && (
              <DashboardItem
                name={"Service Accounts"}
                IconComponent={PointOfSaleIcon}
                action={() => {}}
                isSelected={location.pathname === routes.SERVICE_ACCOUNTS_ROUTE}
                route={routes.SERVICE_ACCOUNTS_ROUTE}
              />
            )}
            {isSuperAdminOrCityAdmin(adminDetails) && (
              <DashboardItem
                name={strings("descriptions.bookings")}
                icon={bookingsIcon}
                action={pressOnBookingsMenu}
                isSelected={location.pathname === routes.BOOKING_ROUTE}
                route={routes.BOOKING_ROUTE}
              />
            )}
            {(isSuperAdmin(adminDetails) ||
              (isSuperAdminOrCityAdmin(adminDetails) &&
                adminDetails?.newBackendEnabled)) && (
              <DashboardItem
                name={strings("descriptions.notifications")}
                IconComponent={SendIcon}
                action={pressOnNotificationsMenu}
                isSelected={location.pathname === routes.NOTIFICATIONS_ROUTE}
                route={routes.NOTIFICATIONS_ROUTE}
              />
            )}
            {isSuperAdminOrCityAdmin(adminDetails) && (
              <DashboardItem
                name={strings("descriptions.settings")}
                icon={settingsIcon}
                action={pressOnSettingsMenu}
                isSelected={location.pathname === routes.SETTINGS_ROUTE}
                route={routes.SETTINGS_ROUTE}
              />
            )}
            <p
              style={{ textAlign: "center", fontSize: 18, fontWeight: "bold" }}
            >
              {getCurrentVersion()}
            </p>
          </div>
        )}

        <div className={"dashboardContainer"}>
          <Routes>
            {pages
              .filter(
                ({ requiresNewBackend }) =>
                  !requiresNewBackend ||
                  isSuperAdmin(adminDetails) ||
                  adminDetails?.newBackendEnabled
              )
              .map(({ path, Component, extraProps }) => (
                <Route
                  path={path.replace(routes.DASHBOARD_SCREEN, "")}
                  key={path}
                  element={<Component {...extraProps} />}
                />
              ))}
            {adminDetails?.cityId === null ? (
              <Route
                path={routes.DASHBOARD_CITIES.replace(
                  routes.DASHBOARD_SCREEN,
                  ""
                )}
                element={
                  <CityContainer
                    changeSearch={changeSearch}
                    searchValue={searchValue}
                    clearSearchValue={clearSearchValue}
                    changePage={setCurrentPageValue}
                    orderProps={orderProps}
                    filterProps={filterProps}
                  />
                }
              />
            ) : null}
            {(isSuperAdmin(adminDetails) ||
              (isSuperAdminOrCityAdmin(adminDetails) &&
                adminDetails?.newBackendEnabled)) && (
              <Route
                path={routes.NOTIFICATIONS_ROUTE.replace(
                  routes.DASHBOARD_SCREEN,
                  ""
                )}
                element={<NotificationsContainer />}
              />
            )}
            {isSuperAdminOrCityAdmin(adminDetails) && (
              <Route
                path={routes.SETTINGS_ROUTE.replace(
                  routes.DASHBOARD_SCREEN,
                  ""
                )}
                element={<SettingsContainer />}
              />
            )}
            {isSuperAdminOrCityAdmin(adminDetails) && (
              <Route
                path={routes.BOOKING_ROUTE.replace(routes.DASHBOARD_SCREEN, "")}
                element={<BookingScreen />}
              />
            )}
            <Route path={"/dashboard/*"} element={<NotFound />} />
          </Routes>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = ({
  auth: { errorMessage, user, city, adminDetails },
  screen: {
    pageSize,
    searchValue,
    filterValue,
    currentPageValue,
    order,
    orderBy,
    typeFilter,
    stationTypeFilter,
    stationStateFilter,
    bikeStateFilter,
  },
  users: { removeUserSuccess },
  stations: { getStationsSuccess },
  vehicle: { getVehicleSuccess, bikesResult },
  locks: { getLocksSuccess },
  docks: { getDocksSuccess },
  cities: { getCitiesSuccess, citiesList, savedCity },
  rentals: { getRentalsSuccess },
}) => ({
  bikesResult,
  errorMessage,
  getStationsSuccess,
  getVehicleSuccess,
  getLocksSuccess,
  getDocksSuccess,
  getCitiesSuccess,
  citiesList,
  getRentalsSuccess,
  removeUserSuccess,
  user,
  city,
  savedCity,
  pageSize,
  searchValue,
  filterValue,
  currentPageValue,
  order,
  orderBy,
  typeFilter,
  stationTypeFilter,
  stationStateFilter,
  bikeStateFilter,
  adminDetails,
});

const mapDispatchToProps = {
  getUsers,
  getStations,
  getPayment,
  getVehicle,
  getLocks,
  getDocks,
  getCities,
  getRentals,
  clearErrorMessage,
  cityList,
  selectCity,
  setSearchValue,
  setFilterValue,
  setCurrentPageValue,
  setOrder,
  setOrderBy,
  getStationsOnMap,
  getBikeStatus,
  getAdminDetails,
  getDockStatuses,
  getBikeTypes,
};

export default connect(mapStateToProps, mapDispatchToProps)(DashboardScreen);
